/* DELOAD — shared theme behaviour: smooth in-page nav, mobile menu, accordions.
   Product-section commerce JS lives inline in main-product.liquid. Homepage film JS is appended by deload-scene-film. */
(function () {
  'use strict';

  /* Smooth in-page navigation — Lenis if present, native fallback, sticky-header offset. */
  function getLenis() { return window.lenis || window.__lenis || null; }
  function navTo(target) {
    if (!target) return;
    var lenis = getLenis();
    if (lenis && typeof lenis.scrollTo === 'function') { lenis.scrollTo(target, { offset: -104 }); return; }
    var y = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0) - 104;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (err) { return; }
    if (!url.hash || url.hash.length < 2) return;
    // Only intercept same-page anchors (e.g. "#faq" on the homepage, or "/#faq"
    // when already on the homepage). Cross-page links like "/#faq" from the
    // product page fall through to native navigation (home, then jump).
    if (url.host !== window.location.host || url.pathname !== window.location.pathname) return;
    var target = document.getElementById(url.hash.slice(1));
    if (!target) return; // unknown anchor → let the browser do its default (e.g. #top)
    e.preventDefault();
    navTo(target);
    if (history && history.replaceState) { history.replaceState(null, '', url.hash); }
    // close mobile menu if open
    document.querySelectorAll('[data-dl-menu].is-open').forEach(function (m) { m.classList.remove('is-open'); });
  });

  /* Mobile menu toggle */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-dl-menu-toggle]');
    if (!t) return;
    var menu = document.querySelector('[data-dl-menu]');
    if (menu) { menu.classList.toggle('is-open'); t.setAttribute('aria-expanded', menu.classList.contains('is-open')); }
  });

  /* Accordion (homepage FAQ / any [data-dl-accordion]) — one open at a time within a group */
  document.querySelectorAll('[data-dl-accordion]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var q = e.target.closest('[data-dl-acc-q]');
      if (!q) return;
      var item = q.parentElement;
      var open = item.classList.contains('is-open');
      group.querySelectorAll('.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      if (!open) item.classList.add('is-open');
    });
  });

  /* Responsive video: pick mobile/desktop source, lazy-load + autoplay only while in view */
  var isMobile = window.matchMedia('(max-width: 820px)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vids = [].slice.call(document.querySelectorAll('[data-dl-video]'));
  vids.forEach(function (v) {
    var src = (isMobile && v.dataset.mobile) ? v.dataset.mobile : v.dataset.desktop;
    if (src) {
      var s = v.querySelector('source');
      if (s) { s.src = src; } else { v.src = src; }
    }
  });
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) { v.load(); v.dataset.loaded = '1'; }
          var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  } else {
    vids.forEach(function (v) { if (!reduce) { v.setAttribute('autoplay', ''); v.load(); } });
  }
})();
